import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import huTranslation from './locales/hu.json';

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      hu: {
        translation: huTranslation
      }
    },
    lng: 'hu', // Set default language to Hungarian
    fallbackLng: 'hu',
    interpolation: {
      escapeValue: false // React already safes from XSS
    }
  });

export default i18n; 